export default function AccountSettings() {
  return <h1>Account Settings</h1>;
}